import { combineReducers } from 'redux';
import ConfigReducer from './Config/ConfigReducer';
import UserReducer from './User/UserReducer';
import SuggestionsReducer from './Suggestions/SuggestionsReducer';
import MessagesReducer from './Messages/MessagesReducer';
import FeedbackReducer from './Feedback/FeedbackReducer';

const rootReducer = combineReducers({
  Config: ConfigReducer,
  User: UserReducer,
  Suggestions: SuggestionsReducer,
  Messages: MessagesReducer,
  Feedback: FeedbackReducer,
});

export default rootReducer;
